module.exports = __webpack_public_path__ + "img/94001641000104.8a0495f7.png";